module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/FilterClose.3d07e30c.svg";